import { Image, Page, Text, View } from '@react-pdf/renderer';
import type { ReactNode } from 'react';
import ZillowMoodys from '../../img/ZillowMoodys.png';
import { styles } from './pdfStyles';

interface MarketTrendsPageWrapperProps {
  children: ReactNode;
  quarter: string;
  year: number;
}

export const MarketTrendsColumn = ({
  children,
  textAlign = 'right',
  width,
}: {
  children?: React.ReactNode;
  textAlign?: 'left' | 'right' | 'center';
  width: number;
}) => <View style={{ ...styles.tableColumn, textAlign, width: `${width}%` }}>{children}</View>;

export const RightAlignColumn = ({ children }: { children: React.ReactNode }) => (
  <View style={{ ...styles.marketPerformanceColumn, ...styles.textAlignRight }}>{children}</View>
);

export const MarketTrendsFooter = ({ quarter, year }: { quarter: string; year: number }) => (
  <View
    style={{
      height: '50px',
      width: '100%',
      backgroundColor: '#001751',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    }}
  >
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width: 200,
      }}
    >
      <View style={{ margin: 10, textAlign: 'left' }}>
        <Image style={{ objectFit: 'scale-down' }} src={ZillowMoodys} />
      </View>
    </View>
    <View
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingRight: 20,
      }}
    >
      <View>
        <Text style={{ fontFamily: 'OpenSans', color: 'white', fontSize: 8 }}>DATA AS OF</Text>
        <Text style={{ fontFamily: 'OpenSansBold', color: 'white', fontSize: 12 }}>{`${quarter} ${year}`}</Text>
      </View>
    </View>
  </View>
);

export const MarketTrendsBaseHeader = () => <View style={{ height: '50px', backgroundColor: '#001751' }} />;

export const MarketTrendsSubHeading = ({ heading }: { heading: string }) => (
  <>
    <View style={{ paddingTop: 5 }}>
      <Text style={styles.paragraphSubHeading}>{heading}</Text>
    </View>
    <View style={{ paddingBottom: 5 }}>
      <View style={{ height: '1px', backgroundColor: '#808080' }} />
    </View>
  </>
);

export const MarketTrendsParagraph = ({ children }: { children: React.ReactNode }) => {
  return <Text style={styles.paragraph}>{children}</Text>;
};

export const MarketTrendsBullet = ({ children }: { children: React.ReactNode }) => {
  return (
    <View style={{ flexDirection: 'row' }}>
      <Text style={styles.bullet}>•</Text>
      <Text style={styles.bulletText}>{children}</Text>
    </View>
  );
};

export const MarketTrendsPageWrapper = ({ children, quarter, year }: MarketTrendsPageWrapperProps) => {
  return (
    <Page
      size="LETTER"
      style={{ backgroundColor: '#FFFFFF', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
    >
      <MarketTrendsBaseHeader />
      <View style={{ flexGrow: 2, maxHeight: '650px' }}>{children}</View>
      <MarketTrendsFooter quarter={quarter} year={year} />
    </Page>
  );
};

export const MarketTrendsHr = () => <View style={{ height: '1px', backgroundColor: 'black' }} />;

export const MarketTrendsTextHeader = ({
  headerText,
  paddingBottom = 10,
  paddingTop = 0,
}: {
  headerText: string;
  paddingBottom?: number;
  paddingTop?: number;
}) => {
  return (
    <>
      <View style={{ paddingBottom: 5, paddingTop }}>
        <Text style={styles.subHeading}>{headerText}</Text>
      </View>
      <View style={{ paddingBottom }}>
        <MarketTrendsHr />
      </View>
    </>
  );
};
